import React from 'react'
import styled from 'styled-components'

import { PlatformUtil } from '@root/shared'
import { type ClassNameProps } from '@root/shared/react'
import { PhotoCameraExactIcon } from '@root/shared/ui-kit'

type GoogleLensHoverProps = ClassNameProps & {
  iconSrc: string
}

export const CurrencyIconGoogleLens = (props: GoogleLensHoverProps) => {
  const href = `https://lens.google.com/uploadbyurl?url=${encodeURIComponent(props.iconSrc)}`

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    e.preventDefault()

    PlatformUtil.openLink(href, '_blank')
  }

  return (
    <GoogleLensHoverRoot
      onClick={handleClick}
      className={props.className}
      href={href}
      target="_blank"
      rel="noreferrer"
      as="span"
    >
      <GoogleLensIcon />
    </GoogleLensHoverRoot>
  )
}

const GoogleLensIcon = styled(PhotoCameraExactIcon)`
  width: 100%;
  height: 100%;
`

const GoogleLensHoverRoot = styled.a`
  padding: 30%;
  border-radius: inherit;
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: var(--appearanceA-4);
  cursor: pointer;

  transition: opacity 0.3s;
  opacity: 0;
  color: var(--background-12);

  &:hover {
    opacity: 1;
  }
`
